/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ClaimContact
 */
export interface ClaimContact {
    /**
     * 
     * @type {number}
     * @memberof ClaimContact
     */
    id: number;
    /**
     * 
     * @type {number}
     * @memberof ClaimContact
     */
    companyId: number;
    /**
     * 
     * @type {number}
     * @memberof ClaimContact
     */
    claimId: number;
    /**
     * 
     * @type {number}
     * @memberof ClaimContact
     */
    contactId: number;
    /**
     * Free-form role (e.g. policyholder, insurance_adjuster, contractor_rep)
     * @type {string}
     * @memberof ClaimContact
     */
    role: string;
    /**
     * 
     * @type {string}
     * @memberof ClaimContact
     */
    notes?: string | null;
    /**
     * Enriched insured name from joined claim table
     * @type {string}
     * @memberof ClaimContact
     */
    insuredName?: string;
    /**
     * Enriched claim number from joined claim table
     * @type {string}
     * @memberof ClaimContact
     */
    claimNumber?: string;
    /**
     * Enriched contact first name from joined contact table
     * @type {string}
     * @memberof ClaimContact
     */
    firstName?: string;
    /**
     * Enriched contact last name from joined contact table
     * @type {string}
     * @memberof ClaimContact
     */
    lastName?: string;
    /**
     * Enriched contact email from joined contact table
     * @type {string}
     * @memberof ClaimContact
     */
    email?: string | null;
    /**
     * Enriched contact type from joined contact table
     * @type {string}
     * @memberof ClaimContact
     */
    contactType?: string;
    /**
     * 
     * @type {Date}
     * @memberof ClaimContact
     */
    createdAt: Date;
}

/**
 * Check if a given object implements the ClaimContact interface.
 */
export function instanceOfClaimContact(value: object): value is ClaimContact {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('companyId' in value) || value['companyId'] === undefined) return false;
    if (!('claimId' in value) || value['claimId'] === undefined) return false;
    if (!('contactId' in value) || value['contactId'] === undefined) return false;
    if (!('role' in value) || value['role'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    return true;
}

export function ClaimContactFromJSON(json: any): ClaimContact {
    return ClaimContactFromJSONTyped(json, false);
}

export function ClaimContactFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClaimContact {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'companyId': json['companyId'],
        'claimId': json['claimId'],
        'contactId': json['contactId'],
        'role': json['role'],
        'notes': json['notes'] == null ? undefined : json['notes'],
        'insuredName': json['insuredName'] == null ? undefined : json['insuredName'],
        'claimNumber': json['claimNumber'] == null ? undefined : json['claimNumber'],
        'firstName': json['firstName'] == null ? undefined : json['firstName'],
        'lastName': json['lastName'] == null ? undefined : json['lastName'],
        'email': json['email'] == null ? undefined : json['email'],
        'contactType': json['contactType'] == null ? undefined : json['contactType'],
        'createdAt': (new Date(json['createdAt'])),
    };
}

export function ClaimContactToJSON(json: any): ClaimContact {
    return ClaimContactToJSONTyped(json, false);
}

export function ClaimContactToJSONTyped(value?: ClaimContact | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'companyId': value['companyId'],
        'claimId': value['claimId'],
        'contactId': value['contactId'],
        'role': value['role'],
        'notes': value['notes'],
        'insuredName': value['insuredName'],
        'claimNumber': value['claimNumber'],
        'firstName': value['firstName'],
        'lastName': value['lastName'],
        'email': value['email'],
        'contactType': value['contactType'],
        'createdAt': ((value['createdAt']).toISOString()),
    };
}

